module.exports = __webpack_public_path__ + "static/img/line.05bf1c84.jpg";